import {match as createMatchFunction, MatchFunction} from 'path-to-regexp'

export type ParamsType = Record<string, any>

export type Handler = (params: ParamsType) => void | Promise<void>

export class Matcher {
    private routes: Array<{match: MatchFunction<ParamsType>, handler: Handler}> = []
    private defaultRoute: null | ((path: string) => void) = null

    handling = false

    constructor(routes: Record<string, Handler> = {}) {
        this.add(routes)
    }

    add(routes: Record<string, Handler>) {
        for (const [path, handler] of Object.entries(routes)) {
            const match = createMatchFunction(path)
            this.routes.push({match, handler})
        }
    }

    setDefault(def: (path: string) => void) {
        this.defaultRoute = def
    }

    async match(path: string): Promise<boolean> {
        for (const {match, handler} of this.routes) {
            const m = match(path)
            if (m) {
                this.handling = true
                await handler(m.params)
                this.handling = false
                return true
            }
        }
        this.defaultRoute?.(path)
        return false
    }
}
